export const defaultHeaders = [
    {
        name: 'agenteFinanceiro',
        text: 'Agente Financeiro',
        order: false,
        position: 1
    },
    {
        name: 'chassi',
        text: 'Chassi',
        order: false,
        position: 2
    },
    {
        name: 'renavam',
        text: 'Renavam',
        order: false,
        position: 3
    },
    {
        name: 'placa',
        text: 'Placa',
        order: false,
        position: 4
    },
    {
        name: 'status',
        text: 'Status',
        order: false,
        position: 5
    },
    {
        name: 'dataRegistro',
        text: 'Data Contrato',
        position: 6
    },
    {
        name: 'detranRegistro',
        text: 'Data Registro',
        position: 7
    },
    {
        name: 'ufDetran',
        text: 'UF Detran',
        position: 8
    },
    {
        name: 'numeroContrato',
        text: 'Nº contrato',
        position: 9
    },
    {
        name: 'valorTotalDivida',
        text: 'Valor Contrato',
        position: 10
    }
]

export const defaultLoaders = [
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    }
]
